import { makeAutoObservable, runInAction } from 'mobx'
import type { Notify } from '@/Ship/Contracts/Notify'
import { ChangePasswordTask } from '../Tasks/ChangePasswordTask'

/**
 * Local store of `ChangePasswordTab`.
 *
 * Was previously inlined three times (UserProfilePage, UserEditTemplate,
 * UserPageTemplate — last deleted in Stage А). All three copies derived the
 * target userId differently; this store accepts it as an explicit `submit()`
 * argument so the view decides where it comes from.
 *
 * Instantiated per tab mount via `useState(() => new ChangePasswordStore())`.
 */
export class ChangePasswordStore {
    newPassword = ''
    confirmPassword = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setNewPassword(v: string): void { this.newPassword = v }
    setConfirmPassword(v: string): void { this.confirmPassword = v }

    reset(): void {
        this.newPassword = ''
        this.confirmPassword = ''
    }

    /**
     * Submit a password change for `userId`.
     * Returns `true` on success; success is reported via `notify.success`.
     */
    async submit(userId: string | undefined | null, notify: Notify): Promise<boolean> {
        if (this.newPassword !== this.confirmPassword) {
            notify.error('Паролі не співпадають')
            return false
        }
        if (!userId) {
            notify.error('Не вдалося визначити ID користувача')
            return false
        }
        this.loading = true
        try {
            await ChangePasswordTask(userId, this.newPassword)
            runInAction(() => {
                this.newPassword = ''
                this.confirmPassword = ''
            })
            notify.success('Пароль змінено')
            return true
        } catch (e: any) {
            notify.error(e?.message || 'Не вдалося змінити пароль')
            return false
        } finally {
            runInAction(() => { this.loading = false })
        }
    }
}
